import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSidebarData } from "../../../redux/slices/sidebar";
import { getDashboardPath, getRoleBasedNavigationLink } from "../../../helper/roleBasedNavigation";

const MobileHamburger = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const sidebarData = useSelector((state) => state.sidebar.data);

  const [showHam, setShowHam] = useState(false);

  // Get user role and entityType
  const role = authState.role;
  const entityType = authState.entityType;
  const dashboardPath = getDashboardPath(role, entityType);

  useEffect(() => {
    dispatch(fetchSidebarData());
  }, [dispatch]);

  const handleHam = () => {
    setShowHam(!showHam);
  };

  // Function to render menu items recursively
  const renderMenuItems = (items) => {
    if (!items || items.length === 0) return null;

    return items.map((item, index) => {
      if (item.type === "program") {
        const NavigationLink = getRoleBasedNavigationLink(
          item?.programCode,
          item?.menuCode,
          role,
          entityType
        );
        return (
          <NavLink
            key={index + "i"}
            to={NavigationLink}
            className={({ isActive }) => (isActive ? classes.active_link : "")}
            onClick={handleHam}
          >
            {item.programName}
          </NavLink>
        );
      }

      // For menu items, render children directly without showing the category name
      // This flattens the menu structure for mobile
      if (item.type === "menu" && item.children) {
        return <div key={index + "i"}>{renderMenuItems(item.children)}</div>;
      }

      return null;
    });
  };

  return (
    <div className={classes.mobile_hamburger}>
      <MenuRoundedIcon onClick={handleHam} className={classes.ham_button} />

      <div
        className={`${classes.nav_container} ${showHam ? classes.show : ""}`}
      >
        <ClearRoundedIcon onClick={handleHam} className={classes.close} />
        <nav className={classes.nav_list}>
          {/* Dashboard Link */}
          <NavLink
            to={dashboardPath}
            end
            className={({ isActive }) => (isActive ? classes.active_link : "")}
            onClick={handleHam}
          >
            Dashboard
          </NavLink>

          {/* Dynamic Menu Items from Sidebar */}
          {renderMenuItems(sidebarData || [])}

          {/* Setting Link */}
          <NavLink
            to="/setting"
            className={({ isActive }) => (isActive ? classes.active_link : "")}
            onClick={handleHam}
          >
            Setting
          </NavLink>
        </nav>
      </div>
    </div>
  );
};

export default MobileHamburger;
